import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    label: 'เมนู',
    isTitle: true,
    link: 'a'
  },
  // {
  //   label: 'Dashboard',
  //   mdiIcon: 'mdi mdi-view-dashboard',
  //   link: '/dashboard'
  // },
  {
    label: 'Dashboard',
    mdiIcon: 'mdi mdi-view-dashboard',
    link: '/dashboard/index',
    allowedPath: ['/dashboard/index']
  },
  {
    label: 'บริหารจัดการข้อมูลหน่วยงาน',
    mdiIcon: 'mdi mdi-city',
    link: '/manage-information/work',
    allowedPath: ['/manage-information/work', '/manage-information/man-power', '/manage-information/agency-info']
  },
  {
    label: 'ตรวจสอบข้อมูลรายการ',
    mdiIcon: 'mdi mdi-clipboard-check-outline',
    link: '/data-verification/index',
    allowedPath: ['/data-verification/index']
  },
  // {
  //   label: 'บริหารจัดการข้อมูลหน่วยงาน',
  //   mdiIcon: 'mdi mdi-city',
  //   link: '/manage-information',
  //   subItems: [
  //     {
  //       label: 'จัดการระดับ ประเภท ภารกิจ สายงาน',
  //       link: 'manage-information/work',
  //     },
  //     {
  //       label: 'จัดข้อมูลอัตรากำลังของหน่วยงาน',
  //       link: 'manage-information/man-power',
  //     },
  //     {
  //       label: 'จัดการข้อมูลหน่วยงาน',
  //       link: 'manage-information/agency-info',
  //     },
  //   ]
  // },
  // {
  //   label: 'บริหารจัดการกรอบอัตราครุภัณฑ์',
  //   icon: 'package',
  //   link: '/equipment',
  //   subItems: [
  //     {
  //       label: 'จัดการกรอบอัตราพัสดุครุภัณฑ์ทั่วไป',
  //       link: 'equipment/tier-index/2',
  //     },
  //     {
  //       label: 'จัดการกรอบอัตราพัสดุด้านครุภัณฑ์ ประจำห้องอบรม สัมมนา ห้องพัก',
  //       link: 'equipment/tier-index/3',
  //     },
  //     {
  //       label: 'จัดการกรอบอัตราพัสดุด้านครุภัณฑ์พิเศษสำหรับสันติบาล',
  //       link: 'equipment/tier-index/4',
  //     },
  //     {
  //       label: 'จัดการกรอบอัตราพัสดุด้านครุภัณฑ์พิเศษสำหรับตรวจคนเข้าเมือง',
  //       link: 'equipment/tier-index/5',
  //     },
  //     {
  //       label: 'จัดการกรอบอัตราพัสดุด้านครุภัณฑ์พิเศษสำหรับศูนย์พิสูจน์หลักฐาน',
  //       link: 'equipment/tier-index/6',
  //     },
  //     {
  //       label: 'จัดการกรอบอัตราพัสดุด้านครุภัณฑ์ พิเศษสำหรับโรงพยาบาล',
  //       link: 'equipment/tier-index/7',
  //     },
  //     {
  //       label: 'จัดการกรอบอัตราพัสดุด้านครุภัณฑ์พิเศษสำหรับตำรวจตระเวนชายแดน',
  //       link: 'equipment/tier-index/8',
  //     },
  //     {
  //       label: 'จัดการกรอบอัตราพัสดุด้านยานพาหนะ',
  //       link: 'equipment/tier-index/9',
  //     },
  //     {
  //       label: 'จัดการกรอบอัตราพัสดุด้านยุทธภัณฑ์',
  //       link: 'equipment/tier-index/10',
  //     },
  //     {
  //       label: 'จัดการกรอบอัตราอาวุธและอุปกรณ์ เครื่องมือทางยุทธวิธี',
  //       link: 'equipment/tier-index/11',
  //     },
  //   ]
  // },
  {
    label: 'บริหารจัดการกรอบอัตราครุภัณฑ์',
    icon: 'package',
    link: '/mst-equipment-quota',
    subItems: [
      {
        label: 'จัดการกรอบอัตราพัสดุ สถานีตำรวจ',
        link: 'mst-equipment-quota/police-station/menu',
        allowedPath: ['/mst-equipment-quota/police-station/menu']
      },
      // {
      //   label: 'จัดการกรอบอัตราพัสดุ กองกำกับการ (ส่วนป้องกันและปราบปรามอาชญากรรม)',
      //   link: 'mst-equipment-quota/crime-suppression/menu',
      // },
      {
        label: 'จัดการกรอบอัตราพัสดุ กองบังคับการตำรวจนครบาล และตำรวจภูธรจังหวัด',
        link: 'mst-equipment-quota/metro-provincial/menu',
        allowedPath: ['/mst-equipment-quota/metro-provincial/menu']
      },
      {
        label: 'จัดการกรอบอัตราพัสดุ กองกำกับการ',
        link: 'mst-equipment-quota/sub-division/menu',
        allowedPath: ['/mst-equipment-quota/sub-division/menu']
      },
      {
        label: 'จัดการกรอบอัตราพัสดุ กองบังคับการ',
        link: 'mst-equipment-quota/division/menu',
        allowedPath: ['/mst-equipment-quota/division/menu']
      },
      {
        label: 'จัดการกรอบอัตราพัสดุ กองบัญชาการ',
        link: 'mst-equipment-quota/command-hq/menu',
        allowedPath: ['/mst-equipment-quota/command-hq/menu']
      },
      {
        label: 'จัดการกรอบอัตราพัสดุ รอง ผบช. ประจำ สง.ผบ.ตร.',
        link: 'mst-equipment-quota/deputy-comm/menu',
        allowedPath: ['/mst-equipment-quota/deputy-comm/menu']
      },
      {
        label: 'จัดการกรอบอัตราพัสดุ ผบช. ประจำ สง.ผบ.ตร.',
        link: 'mst-equipment-quota/commissioner/menu',
        allowedPath: ['/mst-equipment-quota/commissioner/menu']
      },
      {
        label: 'จัดการกรอบอัตราพัสดุ สง. ผู้ช่วย ผบ.ตร.',
        link: 'mst-equipment-quota/assistant-comm/menu',
        allowedPath: ['/mst-equipment-quota/assistant-comm/menu']
      },
      {
        label: 'จัดการกรอบอัตราพัสดุ สง. รอง ผบ.ตร.',
        link: 'mst-equipment-quota/deputy-comm-office/menu',
        allowedPath: ['/mst-equipment-quota/deputy-comm-office/menu']
      },
      {
        label: 'จัดการกรอบอัตราพัสดุ สง.ผบ.ตร',
        link: 'mst-equipment-quota/comm-general/menu',
        allowedPath: ['/mst-equipment-quota/comm-general/menu']

      },
    ]
  },
  {
    label: 'การร้องขอกรอบอัตราพัสดุ',
    icon: 'file-text',
    link: '/request-equipment',
    subItems: [
      {
        label: 'ร้องขอกรอบอัตราพัสดุ',
        link: 'request-equipment/request-index',
        allowedPath: ['/request-equipment/request-index']
      },
      {
        label: 'รออนุมัติกรอบอัตราพัสดุ',
        link: 'request-equipment/approve-index',
        allowedPath: ['/request-equipment/approve-index']

      },
    ]
  },
  {
    label: 'การตั้งค่าพื้นฐานระบบ',
    icon: 'settings',
    link: '/setting',
    subItems: [
      {
        label: 'ภารกิจ',
        link: 'setting/mission',
        allowedPath: ['/setting/mission']
      },
      {
        label: 'ประเภทอาคารหลัก',
        link: 'setting/building-main-type',
        allowedPath: ['/setting/building-main-type']
      },
      {
        label: 'ประเภทอาคารย่อย',
        link: 'setting/building-sub-type',
        allowedPath: ['/setting/building-sub-type']
      },
      {
        label: 'หน่วยนับ',
        link: 'setting/unit',
        allowedPath: ['/setting/unit']
      },
      {
        label: 'ประเภทมาตรฐาน',
        link: 'setting/standard-type',
        allowedPath: ['/setting/standard-type']
      },
      {
        label: 'พื้นฐานหน่วยงาน',
        link: 'setting/master-organize',
        allowedPath: ['/setting/master-organize']
      },
      {
        label: 'งาน',
        link: 'setting/master-job',
        allowedPath: ['/setting/master-job']

      },
      //{
      //  label: 'สายงาน',
      //  link: 'setting/line-of-work',
      //}
    ]
  },
  // {
  //   label: 'การตั้งค่าครุภัณฑ์',
  //   icon: 'settings',
  //   link: '/master-equipment',
  //   subItems: [
  //     {
  //       label: 'ครุภัณฑ์ทั่วไป',
  //       link: 'master-equipment/parcel-index',
  //       allowedPath: ['/master-equipment/parcel-index']
  //     },
  //     {
  //       label: 'ครุภัณฑ์ ประจำห้องอบรม สัมมนา ห้องพัก',
  //       link: 'master-equipment/meeting-index',
  //       allowedPath: ['/master-equipment/meeting-index']
  //     },
  //     {
  //       label: 'ครุภัณฑ์พิเศษสำหรับสันติบาล',
  //       link: 'master-equipment/special-branch-index',
  //       allowedPath: ['/master-equipment/special-branch-index']
  //     },
  //     {
  //       label: 'ครุภัณฑ์พิเศษสำหรับตรวจคนเข้าเมือง',
  //       link: 'master-equipment/immigration-index',
  //       allowedPath: ['/master-equipment/immigration-index']
  //     },
  //     {
  //       label: 'ครุภัณฑ์พิเศษสำหรับศูนย์พิสูจน์หลักฐาน',
  //       link: 'master-equipment/evidence-center-index',
  //       allowedPath: ['/master-equipment/evidence-center-index']
  //     },
  //     {
  //       label: 'ครุภัณฑ์พิเศษสำหรับโรงพยาบาล',
  //       link: 'master-equipment/hospital-index',
  //       allowedPath: ['/master-equipment/hospital-index']
  //     },
  //     {
  //       label: 'ครุภัณฑ์พิเศษสำหรับตำรวจตระเวนชายแดน',
  //       link: 'master-equipment/border-patrol-index',
  //       allowedPath: ['/master-equipment/border-patrol-index']
  //     },
  //     {
  //       label: 'ยานพาหนะ',
  //       link: 'master-equipment/vehical-index',
  //       allowedPath: ['/master-equipment/vehical-index']
  //     },
  //     {
  //       label: 'ยุทธภัณฑ์',
  //       link: 'master-equipment/armament-index',
  //       allowedPath: ['/master-equipment/armament-index']
  //     },
  //     {
  //       label: 'ครุภัณฑ์อาวุธและอุปกรณ์ เครื่องมือทางยุทธวิธี',
  //       link: 'master-equipment/tactical-index',
  //       allowedPath: ['/master-equipment/tactical-index']

  //     },
  //     //{
  //     //  label: 'สายงาน',
  //     //  link: 'setting/line-of-work',
  //     //}
  //   ]
  // },
  {
    label: 'การจัดการครุภัณฑ์',
    icon: 'settings',
    link: '/equipment',
    subItems: [
      {
        label: 'หมวดครุภัณฑ์',
        link: 'setting-equipment/equipment-category',
        allowedPath: ['/equipment/setting-equipment/equipment-category']
      },
      {
        label: 'กลุ่มครุภัณฑ์',
        link: 'setting-equipment/equipment-group',
        allowedPath: ['/equipment/setting-equipment/equipment-group']
      },
      {
        label: 'ข้อมูลครุภัณฑ์',
        link: 'setting-equipment/main-equipment',
        allowedPath: ['/equipment/setting-equipment/main-equipment']

      },
    ]
  },
  {
    label: 'จัดการข้อมูลผู้ใช้งาน',
    icon: 'user',
    link: '/user-management',
    subItems: [
      {
        label: 'กลุ่มสิทธิ์การใช้งาน',
        link: 'user-management/permission-group',
        allowedPath: ['/user-management/permission-group']
      },
      {
        label: 'ผู้ใช้งาน',
        link: 'user-management/user',
        allowedPath: ['/user-management/user']

      },
    ]
  },
  // เมนูช่วยเหลือ — alwaysVisible ให้ทุก role เห็นโดยไม่ต้องผูกกับ permission group
  {
    label: 'คู่มือการใช้งาน',
    mdiIcon: 'mdi mdi-book-open-page-variant',
    link: '/help/manual',
    alwaysVisible: true
  },
  {
    label: 'วิดีโอการใช้งาน',
    mdiIcon: 'mdi mdi-play-circle-outline',
    link: '/help/video',
    alwaysVisible: true
  }
];
